<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  #multiSelectComponent
  [options]="entities"
  [selectedItems]="_selectedEntities"
  (selectedItemsChange)="onSelect($event)"
  (panelShow)="onShowPanel()"
  (panelHide)="onPanelHide($event)"
  (openedChange)="openedChange.emit($event)"
  (onFilter)="search($event.filter)"
  [showToggleAll]="true"
  scrollHeight="300px"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [label]="label"
  [disabled]="disabled"
  [appendTo]="appendTo"
  optionLabel="profile.name"
  filterBy="profile.name"
  [sort]="''"
  [showClear]="showClear"
  [loading]="loading || selectionLoading">
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-multi-select>
